import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './VenueHeader.css';
import React from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { useLocation } from 'react-router-dom';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { ReactComponent as IconStar } from '../../resources/icons/star.svg';
import ShortlistBtn from '../atoms/ShortlistBtn/ShortlistBtn';
var VenueHeader = function VenueHeader(_ref) {
  var fields = _ref.fields,
    rendering = _ref.rendering,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var currentLang = get(sitecoreContext, 'language');
  // const pageSize = params.SearchCount ? parseInt(params.SearchCount) : 10;
  var dictionary = get(fields, 'data.dictionary');
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _get = get(fields, 'data', {}),
    addToFavoriteAnalytics = _get.addToFavoriteAnalytics,
    removeFromFavoriteAnalytics = _get.removeFromFavoriteAnalytics;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var title = get(fields, 'data.item.title.jss.value');
  var introText = get(fields, 'data.item.introText.jss.value');
  var category = get(fields, 'data.item.category.targetItem.title.jss.value');
  var hotelStarRating = parseInt(get(fields, 'data.item.hotelStarRating.targetItem.title.jss.value'));
  var venueID = get(fields, 'data.item.id');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  var variables = BackgroundColorHex ? {
    '--venue-header-background-color': BackgroundColorHex,
    '--venue-header-background-active-color': ActiveColorHex,
    '--venue-header-color': ColorHex
  } : {
    '--venue-header-background-color': selectedPrimaryColor,
    '--venue-header-background-active-color': selectedPrimaryActiveColor,
    '--venue-header-color': getColorByTheme(selectedPrimaryColor)
  };
  React.useEffect(function () {
    if (canUseDOM) {
      var elem = document.querySelector('.header__pagination-dots');
      if (elem) {
        // @ts-ignore
        elem.style.marginBottom = '-28px';
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-header__carousel"
  }, /*#__PURE__*/React.createElement("div", {
    "data-animation-breakpoint": "768",
    className: "header-animation-breakpoint header__poi header__full-width-mob js-header-bm-parent"
  }, /*#__PURE__*/React.createElement(Placeholder, {
    name: "media-header-general",
    rendering: rendering
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-header__category"
  }, category), /*#__PURE__*/React.createElement("div", {
    className: "section-intro"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h3 section__title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "body-small section__desc"
  }, /*#__PURE__*/React.createElement("p", null, introText)), /*#__PURE__*/React.createElement(ShortlistBtn, {
    id: venueID,
    sitecoreContext: sitecoreContext,
    title: title,
    analytics: {
      add: addToFavoriteAnalytics,
      remove: removeFromFavoriteAnalytics
    },
    dynamicColor: BackgroundColorHex ? BackgroundColorHex : selectedPrimaryColor,
    dynamicColorActive: BackgroundColorHex ? ActiveColorHex : selectedPrimaryActiveColor,
    params: params
  })), /*#__PURE__*/React.createElement("div", {
    className: "venue-header__certification"
  }, hotelStarRating ? [/*#__PURE__*/React.createElement(IconStar, {
    key: "1"
  }), /*#__PURE__*/React.createElement(IconStar, {
    key: "2"
  }), /*#__PURE__*/React.createElement(IconStar, {
    key: "3"
  }), /*#__PURE__*/React.createElement(IconStar, {
    key: "4"
  }), /*#__PURE__*/React.createElement(IconStar, {
    key: "5"
  })].slice(0, hotelStarRating) : null)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  })));
};
var commonStyles = "caedddc";
var ltrStyles = "l2ye0w0";
var rtlStyles = "r1cl73jy";
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    style = _ref2.style;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    style: style
  }, children);
};
export default VenueHeader;